// hooks/usePeriod.js
// With concurrent active periods, a section page belongs to a SPECIFIC period
// carried in the route (/section/:period/:sectionKey) rather than to a single
// global active period. This hook resolves that route period against the
// caller's applicable periods from AuthContext.
//
// Returns the same field names section components used to read from useAuth():
//   { period, periodActive, periodLabel, sections, meta }
// so switching a component is just changing the hook it destructures from.

import { useParams } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

export function usePeriod() {
  const { period } = useParams();
  const { periods } = useAuth();
  const meta = (periods || []).find(p => p.period === period) || null;
  return {
    period:       period || null,
    // diConfig only returns ACTIVE periods the user is in, so presence in the
    // list == active-and-applicable. A period not in the list (closed / gated
    // out / unknown) reads as inactive → section pages render read-only.
    periodActive: Boolean(meta),
    periodLabel:  (meta && meta.label) || period || null,
    sections:     (meta && meta.sections) || [],
    phases:       (meta && meta.phases) || [],
    meta,
  };
}
